var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7921 9.67424C23.401 9.29954 22.767 9.29954 22.3759 9.67424L11.4669 20.1739C9.51122 22.0483 6.34028 22.0485 4.38433 20.1744C2.42837 18.3002 2.42818 15.2614 4.38381 13.3869L14.9493 3.22035C16.1321 2.1049 18.0345 2.11952 19.1985 3.25301C20.349 4.37349 20.3493 6.1712 19.199 7.29195L8.63347 17.4585C8.23756 17.8219 7.61315 17.8219 7.21728 17.4585C6.82629 17.0837 6.82629 16.4761 7.21728 16.1013L16.624 7.0453C17.0082 6.66399 16.9973 6.05638 16.5994 5.68812C16.2113 5.32885 15.5959 5.32885 15.2078 5.68812L5.80108 14.7441C4.62756 15.8685 4.62742 17.6917 5.80071 18.8164C6.98995 19.9039 8.86145 19.9043 10.0507 18.8167L20.6152 8.64923C22.5458 6.75133 22.5054 3.71292 20.525 1.86275C18.5799 0.0455688 15.4779 0.0457937 13.5331 1.86316L2.96761 12.0297C0.229545 14.6536 0.229545 18.908 2.96761 21.532C5.70568 24.156 10.145 24.156 12.8831 21.532L23.7921 11.0353C24.1843 10.6615 24.186 10.0537 23.7959 9.67788L23.7921 9.67424Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.a2c5882a92640dd97af92b7e01965a64.svg";
export { ForwardRef as ReactComponent };